var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"night-mode-clock d-flex align-center mr-4"},[_c('div',{staticClass:"clock-display mr-3"},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":"","color":"white"}},[_vm._v("mdi-clock-outline")]),_c('span',{staticClass:"clock-time"},[_vm._v(_vm._s(_vm.currentTime))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }